import React from 'react';
import WhatsAppIcon from './WhatsAppIcon';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NAP } from '../config/nap';
import Reveal from './Reveal';
import {
    MapPin,
    Phone,
    Mail,
    Clock,
    Send,
    Star,
    ChevronRight
} from 'lucide-react';

// Custom SVG Social Media Icons with brand-accurate paths
const SocialIcons = {
    YouTube: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
        </svg>
    ),
    Instagram: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
        </svg>
    ),
    TikTok: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
        </svg>
    ),
    Threads: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.182.408-2.256 1.33-3.022.808-.672 1.91-1.055 3.093-1.079 1.02-.02 1.953.156 2.79.472.019-.776-.013-1.522-.098-2.196-.26-2.056-1.236-3.1-2.895-3.1l-.07.001c-1.034.029-1.835.41-2.381 1.134l-1.647-1.228C8.603 3.91 9.958 3.3 11.663 3.247c2.603.07 4.332 1.58 4.706 4.112.107.72.166 1.511.177 2.36 1.085.568 1.93 1.378 2.477 2.396.795 1.475.946 3.87-.77 5.622C16.556 19.46 14.458 20.22 11.8 20.247h.007z" />
        </svg>
    ),
    X: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
    ),
    WhatsApp: () => <WhatsAppIcon size={20} color="currentColor" />
};

const Footer = () => {
    const { t, i18n } = useTranslation();
    const currentYear = new Date().getFullYear();
    // NAP has Arabic and English forms only; ru/zh visitors see the English
    // address, which is the form the DLD record itself uses.
    const napLang = (i18n.language || 'ar').split('-')[0] === 'ar' ? 'ar' : 'en';

    const quickLinks = [
        { label: t('footer.trustedProjects') || 'مشاريع موثوقة', link: '/projects?category=trusted' },
        { label: t('footer.areas'), link: '/areas' },
        { label: t('footer.developers'), link: '/developers' },
        { label: t('footer.offPlan') || 'قيد الإنشاء', link: '/projects?category=off-plan' },
        { label: t('footer.commercial') || 'تجاري', link: '/projects?category=commercial' },
        { label: t('footer.newProjects') || 'مشاريع جديدة', link: '/projects' },
        { label: t('footer.reSell') || 'إعادة البيع', link: '/re-sell' }
    ];

    const companyLinks = [
        { label: t('footer.aboutUs') || 'من نحن', link: '/about' },
        { label: t('footer.faq') || 'الأسئلة الشائعة', link: '/faq' },
        { label: t('footer.privacyPolicy') || 'سياسة الخصوصية', link: '/privacy' },
        { label: t('footer.termsConditions') || 'الشروط والأحكام', link: '/terms' },
        { label: t('footer.contactUs') || 'تواصل معنا', link: '/contact' }
    ];

    const socialLinks = [
        { Icon: SocialIcons.YouTube, link: 'https://youtube.com/@trust_ainawy', label: 'YouTube' },
        { Icon: SocialIcons.Instagram, link: 'https://www.instagram.com/trust_ainawy', label: 'Instagram' },
        { Icon: SocialIcons.TikTok, link: 'https://www.tiktok.com/@trust_ainawy', label: 'TikTok' },
        { Icon: SocialIcons.Threads, link: 'https://www.threads.com/@trust_ainawy', label: 'Threads' },
        { Icon: SocialIcons.X, link: 'https://x.com/trust_ainawy', label: 'X (Twitter)' },
        { Icon: SocialIcons.WhatsApp, link: 'https://wa.me/message/D3DC5NKCUUWIL1', label: 'WhatsApp Business' }
    ];

    const renderLinks = (items) => (
        <ul className="footer-list">
            {items.map((item) => (
                <li key={item.link + item.label}>
                    <Link to={item.link} className="footer-link">
                        <ChevronRight size={13} className="footer-link-caret" aria-hidden="true" />
                        <span>{item.label}</span>
                    </Link>
                </li>
            ))}
        </ul>
    );

    return (
        <footer className="site-footer">
            <style>{`
                /* No border and no slab of its own colour. A gold line plus a
                   different background made the footer look bolted on; it now
                   just darkens gradually out of whatever precedes it. */
                .site-footer {
                    background: linear-gradient(180deg,
                        rgba(5, 5, 16, 0) 0%,
                        rgba(5, 5, 16, 0.55) 22%,
                        rgba(4, 4, 12, 0.85) 100%);
                    padding-top: 2.5rem;
                }

                .footer-main { padding: 4rem 16px 3rem; }

                /* The brand column carries a paragraph, a rating card and six
                   social buttons, so it gets real width instead of an equal
                   share. The old repeat(auto-fit, minmax(250px,1fr)) gave all
                   four columns the same width and reflowed unpredictably. */
                .footer-grid {
                    display: grid;
                    grid-template-columns: 1.5fr 1fr 1fr 1.4fr;
                    gap: 3rem 2.5rem;
                }

                @media (max-width: 1100px) {
                    .footer-grid { grid-template-columns: 1.4fr 1fr 1.3fr; }
                    .footer-col-company { grid-column: 2; }
                }

                @media (max-width: 820px) {
                    .footer-grid { grid-template-columns: 1fr 1fr; }
                    .footer-brand { grid-column: 1 / -1; }
                    .footer-col-company { grid-column: auto; }
                }

                @media (max-width: 520px) {
                    .footer-grid { grid-template-columns: 1fr; gap: 2.25rem; }
                    .footer-main { padding: 3rem 16px 2.25rem; }
                }

                /* ── Brand ─────────────────────────────────────────────── */
                .footer-logo {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    margin-bottom: 1.15rem;
                }

                .footer-logo img { width: 52px; height: 52px; object-fit: contain; }

                .footer-logo h3 {
                    color: #fff;
                    font-size: 1.25rem;
                    font-weight: 900;
                    letter-spacing: 0.1em;
                    margin: 0;
                    line-height: 1.1;
                }

                .footer-logo span {
                    color: var(--color-neon-blue);
                    font-size: 0.68rem;
                    font-weight: 600;
                    letter-spacing: 0.3em;
                }

                .footer-about {
                    color: rgba(255, 255, 255, 0.6);
                    line-height: 1.75;
                    font-size: 0.92rem;
                    max-width: 42ch;
                    margin: 0 0 1.5rem;
                }

                /* Rating: a quiet row, not a boxed callout. The bordered gold
                   panel was competing with the section headings. */
                .footer-rating {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    flex-wrap: wrap;
                    margin-bottom: 1.75rem;
                }

                .footer-stars { display: inline-flex; gap: 2px; }

                .footer-rating-score {
                    color: var(--color-gold);
                    font-weight: 800;
                    font-size: 1rem;
                }

                .footer-rating-text {
                    color: rgba(255, 255, 255, 0.5);
                    font-size: 0.84rem;
                    margin: 0;
                }

                /* ── Section headings ──────────────────────────────────── */
                .footer-heading {
                    color: #fff;
                    font-size: 0.82rem;
                    font-weight: 700;
                    letter-spacing: 0.16em;
                    text-transform: uppercase;
                    margin: 0 0 1.35rem;
                    padding: 0;
                    border: 0;
                }

                /* A short gold tick rather than a full 2px underline under an
                   inline-block heading — lighter, and the same width whatever
                   the label says in any language. */
                .footer-heading::after {
                    content: '';
                    display: block;
                    width: 26px;
                    height: 2px;
                    border-radius: 2px;
                    background: var(--color-gold);
                    margin-top: 0.6rem;
                }

                /* ── Link lists ────────────────────────────────────────── */
                .footer-list { list-style: none; padding: 0; margin: 0; }
                .footer-list li + li { margin-top: 0.15rem; }

                /* Hover was two JS handlers per link that wrote styles onto
                   e.target — which is the <svg> when the pointer is over the
                   caret, so the padding was applied to the icon instead of the
                   link. Plain CSS has none of that ambiguity. */
                .footer-link {
                    display: flex;
                    align-items: center;
                    gap: 7px;
                    color: rgba(255, 255, 255, 0.62);
                    text-decoration: none;
                    font-size: 0.92rem;
                    padding: 0.42rem 0;
                    transition: color 0.25s ease, transform 0.25s cubic-bezier(0.16, 1, 0.3, 1);
                }

                .footer-link-caret {
                    color: var(--color-gold);
                    opacity: 0;
                    transform: translateX(-5px);
                    transition: opacity 0.25s ease, transform 0.25s cubic-bezier(0.16, 1, 0.3, 1);
                    flex-shrink: 0;
                }

                [dir="rtl"] .footer-link-caret { transform: scaleX(-1) translateX(-5px); }

                .footer-link:hover { color: #fff; transform: translateX(4px); }
                [dir="rtl"] .footer-link:hover { transform: translateX(-4px); }

                .footer-link:hover .footer-link-caret { opacity: 1; transform: translateX(0); }
                [dir="rtl"] .footer-link:hover .footer-link-caret { transform: scaleX(-1); }

                .footer-link:active { opacity: 0.75; }

                /* ── Contact ───────────────────────────────────────────── */
                .footer-address {
                    display: flex;
                    flex-direction: column;
                    gap: 0.9rem;
                    font-style: normal;
                }

                .footer-contact-row {
                    display: flex;
                    align-items: flex-start;
                    gap: 11px;
                    color: rgba(255, 255, 255, 0.65);
                    text-decoration: none;
                    font-size: 0.9rem;
                    line-height: 1.6;
                    transition: color 0.25s ease;
                }

                a.footer-contact-row:hover { color: var(--color-neon-blue); }

                .footer-contact-row svg {
                    color: var(--color-neon-blue);
                    flex-shrink: 0;
                    margin-top: 2px;
                }

                .footer-license {
                    color: rgba(255, 255, 255, 0.42);
                    margin: 0.35rem 0 0;
                    font-size: 0.8rem;
                    line-height: 1.65;
                    padding-top: 0.85rem;
                    border-top: 1px solid rgba(255, 255, 255, 0.07);
                }

                /* ── Social ────────────────────────────────────────────── */
                .footer-social-label {
                    color: rgba(255, 255, 255, 0.45);
                    font-size: 0.78rem;
                    font-weight: 600;
                    letter-spacing: 0.1em;
                    text-transform: uppercase;
                    margin: 0 0 0.85rem;
                }

                .footer-social { display: flex; gap: 9px; flex-wrap: wrap; }

                .footer-social a {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    background: rgba(255, 255, 255, 0.05);
                    border: 1px solid rgba(255, 255, 255, 0.08);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: rgba(255, 255, 255, 0.5);
                    text-decoration: none;
                    transition: color 0.25s ease, background 0.25s ease,
                                border-color 0.25s ease,
                                transform 0.25s cubic-bezier(0.16, 1, 0.3, 1);
                }

                .footer-social a:hover {
                    color: #fff;
                    background: rgba(255, 215, 0, 0.14);
                    border-color: rgba(255, 215, 0, 0.4);
                    transform: translateY(-3px);
                }

                .footer-social a:active { transform: translateY(0) scale(0.93); }

                .footer-social svg { width: 18px; height: 18px; }

                /* ── Bottom bar ────────────────────────────────────────── */
                /* Fades in rather than starting at a ruled line. */
                .footer-bar {
                    background: linear-gradient(180deg,
                        rgba(0, 0, 0, 0) 0%,
                        rgba(0, 0, 0, 0.22) 100%);
                    padding: 1.6rem 0 1.35rem;
                }

                .footer-bar-inner {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    align-items: center;
                    gap: 0.85rem 1.5rem;
                }

                .footer-bar p {
                    color: rgba(255, 255, 255, 0.45);
                    margin: 0;
                    font-size: 0.85rem;
                }

                .footer-bar-links {
                    display: flex;
                    gap: 1.5rem;
                    flex-wrap: wrap;
                    align-items: center;
                }

                .footer-bar-links a,
                .footer-bar-links button {
                    color: rgba(255, 255, 255, 0.45);
                    text-decoration: none;
                    font-size: 0.85rem;
                    background: none;
                    border: none;
                    cursor: pointer;
                    padding: 0;
                    font-family: inherit;
                    transition: color 0.25s ease;
                }

                .footer-bar-links a:hover,
                .footer-bar-links button:hover { color: var(--color-gold); }
            `}</style>

            <div className="container footer-main">
                <div className="footer-grid">
                    {/* Brand */}
                    <Reveal className="footer-brand" delay={0}>
                        <div className="footer-logo">
                            <img src="/logo-256.webp" alt="Al-Zaeem Logo" width={128} height={128} loading="lazy" decoding="async" />
                            <div>
                                <h3>AL-ZAEEM</h3>
                                <span>AL-AINAWI</span>
                            </div>
                        </div>

                        <p className="footer-about">
                            {t('footer.companyDescription') || 'شريكك الموثوق في عالم العقارات الفاخرة في دبي. نقدم لك أفضل الفرص الاستثمارية والعقارات المتميزة.'}
                        </p>

                        <div className="footer-rating">
                            <span className="footer-stars">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <Star key={star} size={15} fill="#FFD700" color="#FFD700" />
                                ))}
                            </span>
                            <span className="footer-rating-score">4.9</span>
                            <p className="footer-rating-text">
                                {t('footer.ratingText') || 'تقييم العملاء من 500+ مراجعة'}
                            </p>
                        </div>

                        <p className="footer-social-label">
                            {t('footer.followUs') || 'Stay in touch with us:'}
                        </p>
                        <div className="footer-social">
                            {socialLinks.map((social) => (
                                <a
                                    key={social.label}
                                    href={social.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={social.label}
                                    title={social.label}
                                >
                                    <social.Icon />
                                </a>
                            ))}
                        </div>
                    </Reveal>

                    {/* Quick links */}
                    <Reveal className="footer-col" delay={0.07}>
                        <h4 className="footer-heading">{t('footer.quickLinks') || 'روابط سريعة'}</h4>
                        {renderLinks(quickLinks)}
                    </Reveal>

                    {/* Company */}
                    <Reveal className="footer-col footer-col-company" delay={0.14}>
                        <h4 className="footer-heading">{t('footer.company') || 'الشركة'}</h4>
                        {renderLinks(companyLinks)}
                    </Reveal>

                    {/* Contact */}
                    <Reveal className="footer-col" delay={0.21}>
                        <h4 className="footer-heading">{t('footer.contactInfo') || 'معلومات التواصل'}</h4>

                        {/*
                          NAP block. Every value comes from src/config/nap.js —
                          the same source as the JSON-LD and the prerendered
                          HTML — so the address, phone and hours are
                          byte-identical everywhere on the site. Google matches
                          a business across the web by exact-string agreement on
                          these three.

                          Marked up as <address> so the semantics are legible
                          without parsing JSON-LD.
                        */}
                        <address className="footer-address">
                            <div className="footer-contact-row">
                                <MapPin size={18} />
                                <span>{t('footer.address', { defaultValue: NAP.address.full[napLang] })}</span>
                            </div>

                            <a href={`tel:${NAP.phone}`} className="footer-contact-row">
                                <Phone size={18} />
                                <span dir="ltr">{NAP.phoneDisplay}</span>
                            </a>

                            <a href={`mailto:${NAP.email}`} className="footer-contact-row">
                                <Mail size={18} />
                                <span dir="ltr">{NAP.email}</span>
                            </a>

                            <div className="footer-contact-row">
                                <Clock size={18} />
                                <span>{t('footer.workingHours', { defaultValue: NAP.openingHours.display[napLang] })}</span>
                            </div>

                            {/* The licence number is the trust signal answer
                                engines quote when asked whether we are
                                legitimate — so it belongs in visible text, not
                                only in schema. */}
                            <p className="footer-license">
                                {t('footer.license', {
                                    defaultValue: `وسيط عقاري مرخّص من دائرة الأراضي والأملاك بدبي — رقم ${NAP.dldBrokerNumber}`
                                })}
                            </p>
                        </address>
                    </Reveal>
                </div>
            </div>

            <div className="footer-bar">
                <div className="container footer-bar-inner">
                    <p>© {currentYear} {t('footer.copyright') || 'الزعيم العقارية. جميع الحقوق محفوظة.'}</p>
                    <div className="footer-bar-links">
                        <Link to="/privacy">{t('footer.privacyPolicy') || 'سياسة الخصوصية'}</Link>
                        <Link to="/terms">{t('footer.termsConditions') || 'الشروط والأحكام'}</Link>
                        <button
                            type="button"
                            onClick={() => {
                                try { localStorage.removeItem('trustainawy_cookie_consent_v1'); } catch { /* private mode */ }
                                window.location.reload();
                            }}
                        >
                            {t('footer.cookiePreferences') || 'إعدادات ملفات تعريف الارتباط'}
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
